module.exports = __webpack_public_path__ + "media/images/new-ui-images/blue-plan-24e90843d6e7c036ffebac27b92be3ce.svg";